module.exports = __webpack_public_path__ + "img/notification-icon.17fdbe37.svg";